import { isEmpty,uniqBy } from 'lodash'
import { observable, action } from 'mobx'
import { PAGE_SIZE } from '../helpers/constants'
import api from '../common/api'
import { Request2 } from 'src/common/Request2'
import { responseDefault } from './store.constants'
import { STATUS_ACTIVITY } from '../helpers/constants'

export class JobsStore {
   @observable jobs: any = { ...responseDefault }
   @observable jobsRecruiting: any = { ...responseDefault } //NEW: 0,
   @observable jobsProcessing: any = { ...responseDefault } //    DOING: 1,
   @observable jobsReview: any = { ...responseDefault } //    REVIEW: 2,
   @observable jobsEditing: any = { ...responseDefault } //    REJECT: 3,
   @observable jobsDone: any = { ...responseDefault } //    FINISH: 4,
   @observable jobsCount: any = {}
   @observable textSearch: string = ''
   @observable fieldFilter: any = {}
   @observable jobTotal: any = {}
   // Bam hashtag trong chi tiet job -> danh sach dang mo tim theo "#ten". `at` de bam lai cung hashtag van tim
   @observable hashtagSearch: { name: string; at: number } = { name: '', at: 0 }

   @action
   async action_updateJobPriority(index: number, status: boolean) {
      let rows1 = JSON.parse(JSON.stringify(this.jobs?.rows));
      console.log('row1', rows1, 'rows1[index]', rows1[index], 'rows1[index]?.isPriority', rows1[index]?.isPriority);
      // Set job thành job ưu tiên
      rows1[index] = { ...rows1[index], isPriority: status }
      this.jobs.rows = [...rows1]
      console.log('   rows1[index]', rows1[index]);

   }
   @action
   async action_updateJobAssign(index: number, designer: any) {
      let rows1 = JSON.parse(JSON.stringify(this.jobs?.rows));
      console.log('row1', rows1, 'rows1[index]', rows1[index], 'rows1[index]?.isPriority', rows1[index]?.isPriority);
      // Gán designer cho job
      // Chuyển job mới thành Đang xử lý: status 0=>1
      rows1[index] = { ...rows1[index], designer, status: 1 }
      this.jobs.rows = [...rows1]
      console.log('   rows1[index]', rows1[index]);
   }

   /**
    * Vá lại một dòng trong bảng quản lý việc mà không phải tải lại cả trang.
    * Dùng khi sửa nhanh url / link design / seller ngay trên bảng.
    */
   @action
   async action_patchJobRow(jobId: number, patch: any) {
      const rows = [...(this.jobs?.rows || [])]
      const index = rows.findIndex((item: any) => item?.id === jobId)
      if (index < 0) return
      rows[index] = { ...rows[index], ...patch }
      this.jobs = { ...this.jobs, rows }
   }

   /**
    * Admin/supporter sửa url / link design / seller. Chỉ truyền trường cần đổi,
    * trường không truyền server giữ nguyên.
    */
   @action
   async updateJobInfo(jobId: number | string, data: any) {
      const result = await Request2.postWithToken(data, api.job.managerUpdate + '/' + jobId)
      return result
   }

   /**
    * Gán một việc cho designer, không hiện popup lỗi để gọi hàng loạt.
    */
   @action
   async assignJobSilent(jobId: number | string, designerId: number | string) {
      return await Request2.postWithTokenNoMessage({ designerId }, api.job.assignee + '/' + jobId)
   }

   @action
   async action_removeJob(jobId: number) {
      console.log('action_removeJob job');
      let rows1 = JSON.parse(JSON.stringify(this.jobsRecruiting?.rows));
      // console.log('row1', rows1, 'rows1[index]', rows1[index], 'rows1[index]?.isPriority', rows1[index]?.isPriority);
      // Gán designer cho job
      // Chuyển job mới thành Đang xử lý: status 0=>1
      const index = rows1.findIndex((item:any) => jobId === item.id)
      if (index > -1) {
         
         rows1?.splice(index, 1)
      }
      console.log('action_removeJob job index',index);
      // rows1[index] = { ...rows1[index], designer, status: 1 }
      this.jobsRecruiting.rows = [...rows1]
      console.log('   rows1[index]', rows1[index]);
   }
   @action
   async action_ClearItemJobsRecruiting(data:any) {
      let rows1 = JSON.parse(JSON.stringify(this.jobsRecruiting?.rows));
      const index = rows1.findIndex((item:any) => data.jobId === item.id)
      if (index > -1) {
         rows1?.splice(index, 1)
      }
      // console.log('row1', rows1, 'rows1[index]', rows1[index], 'rows1[index]?.isPriority', rows1[index]?.isPriority);
      // Gán designer cho job
      // Chuyển job mới thành Đang xử lý: status 0=>1
     
      // rows1[index] = { ...rows1[index], designer, status: 1 }
      rows1.push(data)
      this.jobsRecruiting.rows = [...rows1]
   }
   @action
   async action_setItemJobsRecruiting(data:any) {
      let rows1 = JSON.parse(JSON.stringify(this.jobsRecruiting?.rows));
      // console.log('row1', rows1, 'rows1[index]', rows1[index], 'rows1[index]?.isPriority', rows1[index]?.isPriority);
      // Gán designer cho job
      // Chuyển job mới thành Đang xử lý: status 0=>1
     
      // rows1[index] = { ...rows1[index], designer, status: 1 }
      rows1.push(data)
      this.jobsRecruiting.rows = uniqBy([...rows1], 'id');
   }
   // Hashtag vua duoc luu -> cap nhat dong tuong ung o moi danh sach dang giu
   @action
   action_setJobTag(id: number, tag: string) {
      this.action_patchJob(id, { tag })
   }

   // Job vua duoc sua (so luong mau, hashtag...) -> cap nhat dong tuong ung o moi danh sach dang giu
   @action
   action_patchJob(id: number, patch: any) {
      const update = (list: any) =>
         list?.rows
            ? { ...list, rows: list.rows.map((job: any) => (job?.id === id ? { ...job, ...patch } : job)) }
            : list
      this.jobs = update(this.jobs)
      this.jobsRecruiting = update(this.jobsRecruiting)
      this.jobsProcessing = update(this.jobsProcessing)
      this.jobsReview = update(this.jobsReview)
      this.jobsEditing = update(this.jobsEditing)
      this.jobsDone = update(this.jobsDone)
   }

   @action
   action_searchHashtag(name: string) {
      this.hashtagSearch = { name, at: Date.now() }
   }

   @action
   async action_setTextSearch(text: string) {
      this.textSearch = text
   }

   @action
   async action_setFieldFilter(data: any) {
      this.fieldFilter = { ...data }
   }

   /**
    * Tổng SL mẫu / tổng tiền phải khớp với đúng tập việc đang hiển thị,
    * nên gửi nguyên bộ lọc (kể cả khoảng ngày) chứ không chỉ mỗi status.
    */
   @action
   async getJobTotal(params: any = {}) {
      const param = typeof params === 'string' ? { status: params } : { ...params }
      delete param['offset']
      delete param['limit']
      const result = await Request2.getWithToken(api.job.total, param)
      // console.log('getJobTotal', result);
      if (!isEmpty(result)) {
         this.jobTotal = result
      }
   }


   @action
   async getJobList(params: any = {}, history?: any) {
      let param = { ...params }
      if (param?.isPriority) {
         param.isPriority = true
      } else {
         delete param['isPriority']
      }
      const result = await Request2.getWithToken(api.job.getList, { ...param, ...{ limit: PAGE_SIZE } })
      if (!isEmpty(result)) {
         if (params?.status === STATUS_ACTIVITY.NEW) {
            if (params?.offset !== 0 && params?.offset !== this.jobsRecruiting.offset) {
               this.jobsRecruiting = { ...result, rows: this.jobsRecruiting?.rows.concat(result?.rows) }
            } else {
               this.jobsRecruiting = result
            }
         }
         if (params?.status === STATUS_ACTIVITY.DOING) {
            if (params?.offset !== 0 && params?.offset !== this.jobsProcessing.offset) {
               this.jobsProcessing = { ...result, rows: this.jobsProcessing?.rows.concat(result?.rows) }
            } else {
               this.jobsProcessing = result
            }
         }
         if (params?.status === STATUS_ACTIVITY.REVIEW) {
            if (params?.offset !== 0 && params?.offset !== this.jobsReview.offset) {
               this.jobsReview = { ...result, rows: this.jobsReview?.rows.concat(result?.rows) }
            } else {
               this.jobsReview = result
            }
         }
         if (params?.status === STATUS_ACTIVITY.REJECT) {
            if (params?.offset !== 0 && params?.offset !== this.jobsEditing.offset) {
               this.jobsEditing = { ...result, rows: this.jobsEditing?.rows.concat(result?.rows) }
            } else {
               this.jobsEditing = result
            }
         }
         if (params?.status === STATUS_ACTIVITY.FINISH) {
            if (params?.offset !== 0 && params?.offset !== this.jobsDone.offset) {
               this.jobsDone = { ...result, rows: this.jobsDone?.rows.concat(result?.rows) }
            } else {
               this.jobsDone = result
            }
         }
         // if (isUndefined(params?.status) || isNull(params?.status)) this.jobs = result
      }
   }
   /**
    * Export Excel theo bộ lọc (không phân trang). Server tự giới hạn designer
    * chỉ lấy việc hoàn thành của mình.
    */
   @action
   async exportJobs(params: any = {}) {
      const param = { ...params }
      if (param?.isPriority) {
         param.isPriority = true
      } else {
         delete param['isPriority']
      }
      delete param['offset']
      delete param['limit']
      return await Request2.downloadWithToken(api.job.export, param)
   }

   @action
   async getJobListAdmin(params: any = {}) {
      let param = { ...params }
      if (param?.isPriority) {
         param.isPriority = true
      } else {
         delete param['isPriority']
      }
      const result = await Request2.getWithToken(api.job.getList, { ...param, ...{ limit: PAGE_SIZE } })
      this.getJobTotal(param)
      if (!isEmpty(result)) {
         this.jobs = result
      }
   }

   @action
   async action__cardBtn(api: string, params: any = {}) {
      const result = await Request2.postWithToken({}, api)
      return result
   }

   @action
   async updateJob(params: any = {}, id: string | number) {
      const result = await Request2.postWithToken(params, api.job.update + '/' + id)
      return result
   }

   @action
   async deleteJob(id: string | number) {
      const result = await Request2.postWithToken({}, api.job.delete + '/' + id)
      return result
   }

   @action
   async cancelJob(id: string | number) {
      const result = await Request2.postWithToken({}, api.job.cancel + '/' + id)
      return result
   }

   /**
    * Admin/supporter duyet viec dang cho duyet -> viec hien len cho designer.
    * Truyen `designerId` thi viec duyet xong duoc giao luon cho designer do.
    */
   @action
   async approveJob(id: string | number, designerId?: number | string | null) {
      const result = await Request2.postWithToken(
         designerId ? { designerId } : {},
         api.job.approve + '/' + id
      )
      return result?.code === 200
   }

   /**
    * Admin/supporter chuyen thang viec cho duyet sang hoan thanh, khong qua designer.
    */
   @action
   async approveAndFinishJob(id: string | number) {
      const result = await Request2.postWithToken({}, api.job.approveFinish + '/' + id)
      return result?.code === 200
   }

   /**
    * Duyet mot viec dang cho duyet, khong hien popup loi de goi hang loat.
    * Co the kem `designerId` de giao luon cho designer do.
    */
   @action
   async approveJobSilent(id: string | number, designerId?: number | string | null) {
      return await Request2.postWithTokenNoMessage(
         designerId ? { designerId } : {},
         api.job.approve + '/' + id
      )
   }

   /**
    * Hoan thanh mot viec, khong hien popup loi de goi hang loat.
    */
   @action
   async finishJobSilent(id: string | number) {
      return await Request2.postWithTokenNoMessage({}, api.job.approveFinish + '/' + id)
   }

   /**
    * Huy mot viec, khong hien popup loi de goi hang loat.
    */
   @action
   async cancelJobSilent(id: string | number) {
      return await Request2.postWithTokenNoMessage({}, api.job.cancel + '/' + id)
   }

   /**
    * Xoá một việc, không hiện popup lỗi để gọi hàng loạt.
    */
   @action
   async deleteJobSilent(id: string | number) {
      return await Request2.postWithTokenNoMessage({}, api.job.delete + '/' + id)
   }

   @action
   async getJobCount() {
      const result = await Request2.getWithToken(api.job.count)
      if (result) this.jobsCount = result
      return result
   }

   @action
   async resetJobCount(type: string) {
      this.jobsCount[type] = 0
   }

   @action
   async receiveNewJobs() {
      this.jobsCount = { ...this.jobsCount, new: this.jobsCount?.new + 1 || 0 }
   }

   @action
   async isAbleToReceiveJobs() {
      const result = await Request2.getWithToken(api.job.isReceive)
      return result
   }

   @action
   resetJobs() {
      this.jobs = { ...responseDefault }
      this.jobsRecruiting = { ...responseDefault }
      this.jobsProcessing = { ...responseDefault }
      this.jobsReview = { ...responseDefault }
      this.jobsEditing = { ...responseDefault }
      this.jobsDone = { ...responseDefault }
   }
}
